// removed by extract-text-webpack-plugin
module.exports = {"progressBar":"progress-bar__progressBar-3zGi0","progressBarInner":"progress-bar__progressBarInner-DtzZ_","progressPercentage":"progress-bar__progressPercentage-j74TP","progressName":"progress-bar__progressName-_vFZ3"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/bitrix-export-leads/progress-bar/progress-bar.css
// module id = 753
// module chunks = 0